﻿document.addEventListener('DOMContentLoaded', () => {
    window.gro = window.gro || {};
    window.gro.modules = window.gro.modules || {};

    window.gro.modules.favorites = {
        /**
         * @description Lists the user's favorite items in the top navigation.
         * @returns {void}
         */
        listFavorites: async () => {
            // Don't fetch favorites if it's the internal page or favorites not loaded
            if (document.querySelector('body.internal-page') ||
                !document.getElementById('favorites-topnav'))
            {
                return;
            }

            try {
                const response = await fetch('/api/favorites/get-favorite-list-items', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({}),
                });

                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }

                const data = await response.text();

                const favoritesTopnav = document.getElementById('favorites-topnav');

                if (!favoritesTopnav) {
                    return;
                }

                favoritesTopnav.innerHTML = data;
            } catch (error) {
                console.error('Något gick fel vid hämtning av favoriter.', error);
            }
        },

        /**
         * @description Adds a favorite to the user's favorite list.
         * @param {Event} event - The event object.
         * @param {number} pageId - The page id.
         */
        addFavorite: async (event, pageId) => {
            try {
                const response = await fetch('/api/favorites/add-favorite', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                    },
                    body: new URLSearchParams({ pageId }),
                });

                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }

                window.gro.modules.favorites.listFavorites();
            } catch (error) {
                const countElement = document.getElementById('favorites-navigation-count');
                let count = parseInt(countElement.dataset.favoriteCount, 10);
                countElement.dataset.favoriteCount = ++count;
                alert('Något gick fel vid tilläggning av favorit.');
                event.target.classList.toggle('active');
            }
        },

        /**
         * @description Removes a favorite from the user's favorite list.
         * @param {Event} event - The event object.
         * @param {number} pageId - The page id.
         */
        removeFavorite: async (event, pageId) => {
            try {
                const response = await fetch('/api/favorites/remove-favorite', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                    },
                    body: new URLSearchParams({ pageId }),
                });

                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }

                window.gro.modules.favorites.listFavorites();
            } catch (error) {
                const countElement = document.getElementById('favorites-navigation-count');
                let count = parseInt(countElement.dataset.favoriteCount, 10);
                countElement.dataset.favoriteCount = ++count;

                alert('Något gick fel vid borttagning av favorit.');
                event.target.classList.toggle('active');
            }
        },

        /**
         * @description Handles the click event for the favorite icon.
         */
        favoriteIconClick: () => {
            document.addEventListener('click', (e) => {
                let target = e.target;
                // Traverse up the DOM tree to find the button with the class 'js-sub-navigation-favorite'
                while (target && !target.classList.contains('js-sub-navigation-favorite')) {
                    target = target.parentElement;
                }

                if (target && target.classList.contains('js-sub-navigation-favorite')) {
                    e.stopPropagation();
                    e.preventDefault();

                    const pageId = target.dataset.pageId;
                    const countElement = document.getElementById('favorites-navigation-count');
                    let count = parseInt(countElement.dataset.favoriteCount, 10);

                    if (target.classList.contains('active')) {
                        target.classList.toggle('active');
                        countElement.dataset.favoriteCount = --count;
                        window.gro.modules.favorites.removeFavorite(e, pageId);
                    } else {
                        if (count < 10) {
                            target.classList.toggle('active');
                            countElement.dataset.favoriteCount = ++count;
                            window.gro.modules.favorites.addFavorite(e, pageId);
                        } else {
                            document
                                .getElementById('max-navigation-favorites-modal')
                                .classList.remove('hidden');
                        }
                    }
                }
            });
        },
    };

    // Initialize the favorites module
    window.gro.modules.favorites.listFavorites();
    window.gro.modules.favorites.favoriteIconClick();
});
